import { render, staticRenderFns } from "./Consumen.vue?vue&type=template&id=4455613a&scoped=true"
import script from "./Consumen.vue?vue&type=script&lang=js"
export * from "./Consumen.vue?vue&type=script&lang=js"
import style0 from "./Consumen.vue?vue&type=style&index=0&id=4455613a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4455613a",
  null
  
)

export default component.exports